import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
  Column,
  ElevatedForm,
  CancelButton,
  SubmitButton,
  TextFieldWithError
} from '../../Forms/FormComponents';
import { FormTop, FormBottom } from '../SharedSC/FormSC';

const FormTopSC = styled(FormTop)`
  margin-bottom: 1.5rem;
`;

const InstitutionTypeForm = ({
  type,
  entityLabel,
  buttonText,
  handleChange,
  onSubmit,
  showValidationErrors,
  validateName,
  onFormClose
}) => (
  <ElevatedForm>
    <FormTopSC>
      <Column size="100%">
        <TextFieldWithError
          id="typeName"
          name="name"
          value={type.name}
          onChange={event => handleChange(event)}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          label={`${entityLabel}*`}
          placeholder=""
          variant="outlined"
          validate={validateName}
          showValidationErrors={showValidationErrors}
        />
      </Column>
    </FormTopSC>
    <FormBottom>
      <CancelButton onClick={onFormClose} noHoverBg>
        Cancel
      </CancelButton>
      <SubmitButton onClick={onSubmit}>{buttonText}</SubmitButton>
    </FormBottom>
  </ElevatedForm>
);

InstitutionTypeForm.propTypes = {
  type: PropTypes.object,
  buttonText: PropTypes.string,
  entityLabel: PropTypes.string,
  showValidationErrors: PropTypes.bool,
  handleChange: PropTypes.func,
  onSubmit: PropTypes.func,
  validateName: PropTypes.func.isRequired,
  onFormClose: PropTypes.func
};
InstitutionTypeForm.defaultProps = {
  type: {},
  buttonText: 'Create',
  entityLabel: 'Type',
  showValidationErrors: false,
  handleChange: undefined,
  onSubmit: undefined,
  onFormClose: undefined
};

export default InstitutionTypeForm;
